<template>
    <div class="container" style="padding: 120px 0 0">
        <v-btn @click="borrarDocumentosAntiguos">Borrar Documentos Antiguos</v-btn>
    </div>
</template>
<script>
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
    name: 'BorrarAbonosAntiguos',
    methods: {
        borrarDocumentosAntiguos() {
            const fechaLimite = '2024-08-01'; // Ajusta la fecha según tus necesidades
            const fechaLimiteObj = new Date(fechaLimite);
            const fechaLimiteTimestamp = fechaLimiteObj.getTime();
            const query = firebase.firestore().collection('abonos').where('fechaCreate', '<', fechaLimiteTimestamp);
            let documentosEliminados = 0;

            query.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                doc.ref.delete().then(() => {
                    console.log(`Documento eliminado con ID: ${doc.id}`);
                    documentosEliminados++;
                }).catch((error) => {
                    console.error(`Error al eliminar el documento: ${error}`);
                }).finally(() => {
                    console.log(`Total de documentos eliminados: ${documentosEliminados}`);
                });
            });
            }).catch((error) => {
                console.error(`Error al obtener los documentos: ${error}`);
            });
        }
    }

}   

</script>